import {
  ButtonSpinner,
  ButtonWrapper,
  ButtonSpinnerProgress,
} from 'components/Ui/styled';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import { formatDate, formatDateTime } from 'utils/commonUtils';
import { BulkSignOffButtonGrid, SpedGridForm } from '../spedNotesStyled';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

export const bulkSignOffSpedNotesColumns = (selectedIds, setSelectedIds) => [
  {
    width: 50,
    field: 'action',
    sortable: false,
    headerName: 'Action',
    disableColumnMenu: true,

    renderCell: (params) => {
      const id = params?.row?.id;

      const isChecked = selectedIds?.includes(id);

      const handleChange = () => {
        if (isChecked) {
          setSelectedIds(selectedIds?.filter((x) => x !== id));
        } else {
          setSelectedIds([...(selectedIds || []), id]);
        }
      };

      return (
        <Checkbox checked={isChecked} onChange={handleChange} color="primary" />
      );
    },
  },
  {
    flex: 1,
    field: 'studentId',
    headerName: 'Student ID',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    headerName: 'Provider',
    field: 'serviceProvider',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'serviceType',
    headerName: 'Service Type',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'serviceDate',
    headerName: 'Service Date',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'location',
    headerName: 'Location',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    headerName: 'Status',
    field: 'sessionStatus',
    renderCell: renderCellExpand,
  },
  {
    flex: 1,
    field: 'notes',
    headerName: 'Notes',
    renderCell: renderCellExpand,
  },
];

export const bulkSignOffSpedNotesListData = (spedNotesData) => {
  if (!spedNotesData || spedNotesData?.length === 0) {
    return [];
  }

  return spedNotesData.map((item) => {
    return {
      ...item,
      notes: item?.notes,
      id: item?.resourceId,
      archived: item?.archived,
      location: item?.location,
      studentId: item?.studentId,
      resourceId: item?.resourceId,
      esignature: item?.esignature,
      serviceType: item?.serviceType,
      sessionStatus: item?.sessionStatus,
      seifEsignature: item?.seifEsignature,
      createdAt: formatDate(item?.createdAt),
      updatedAt: formatDate(item?.updatedAt),
      serviceProvider: item?.serviceProvider,
      seifSignatureAgree: item?.seifSignatureAgree,
      noteSignatureAgree: item?.noteSignatureAgree,
      serviceDate: formatDateTime(item?.serviceDate),
      serviceDurationMinutes: item?.serviceDurationMinutes,
    };
  });
};

export const renderBulkSignOffSaveButton = (
  handleSubmit,
  loading,
  disableSave = false,
) => {
  return (
    <ButtonWrapper container>
      <ButtonSpinner>
        <Box sx={{ m: 1, position: 'relative' }}>
          <Button
            variant="text"
            onClick={handleSubmit}
            disabled={loading || disableSave}
            data-testid="save-button"
          >
            Save
          </Button>

          {loading && <ButtonSpinnerProgress size={24} />}
        </Box>
      </ButtonSpinner>
    </ButtonWrapper>
  );
};

export const BulkSignOffHeader = ({
  bulkSignOff,
  setBulkSignOff,
  handleBulkSignOff,
}) => {
  return (
    <SpedGridForm container>
      <Grid item xs={12} md={3}>
        {bulkSignOff && (
          <Button
            sx={{ pl: '8px' }}
            variant="text"
            onClick={() => setBulkSignOff(false)}
          >
            ↩ Back to Create SPED Notes
          </Button>
        )}
      </Grid>

      <BulkSignOffButtonGrid item md={9} xs={12}>
        <Button variant="text" onClick={handleBulkSignOff}>
          Bulk Sign Off
        </Button>
      </BulkSignOffButtonGrid>
    </SpedGridForm>
  );
};
